import { useContext } from 'react'
import Modal, { ModalHeader, ModalBody } from '../../../common/Modal'
import {
  InlineConnectionContext,
  SET_SHOW_HIDE_INLINE_POPUP,
} from '../context/context'
import InlineConnectionsForm from './InlineConnectionsForm'

const InlinesConnectionsFormModal = (props) => {
  const [inlineState, inlineDispatch] = useContext(InlineConnectionContext)
  return (
    <Modal
      onClose={() => {
        inlineDispatch({
          type: SET_SHOW_HIDE_INLINE_POPUP,
          data: false,
        })
      }}
      show={inlineState?.showInlineFormPopup}
    >
      <ModalHeader className={'text-white'}>Inline Connections</ModalHeader>
      <ModalBody>
        <InlineConnectionsForm
          onSave={() => props.onSave()}
          getListData={() => {
            props.getListData()
          }}
        />
      </ModalBody>
    </Modal>
  )
}

export default InlinesConnectionsFormModal
